import React, { useRef } from 'react';
import ORB4Print from './ORB4Print';
import { IStore } from '../../../../../redux/store';
import { Dispatch } from 'redux';
import { ConnectedProps, connect } from 'react-redux';
import ORB4CoverPage from './ORB4CoverPage';
import { useOnScrollToTop } from '../../../../../hooks/useScrollToTop';
import { marpolSelectors } from '../../../../../redux/app/marpol';
import { getFilteredTanks } from 'redux/app/vessel/inspector/utils';
import TankWithPositionTable from 'components/app/vessel/onboard/inspector/_elements/TankWithPositionTable';
import orb4Selectors from 'redux/app/orb4/selectors';
import { TORB4HistoryFilters } from 'redux/app/orb4/@types';
import orb4Actions from 'redux/app/orb4/actions';

type OwnProps = {
    showCoverPages?: boolean;
	vesselId: string;
};
type ORB4HistoryProps = PropsFromRedux & OwnProps;

function ORB4InspectorView(props: ORB4HistoryProps) {
    const { historyList, showCoverPages, tanks, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);

    const filteredTanks = getFilteredTanks(tanks, 'type', [
        'CARGO_TANK',
        'SLOP_TANK',
    ]);

    return (
        <div>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? (
                <ORB4CoverPage vesselId={vesselId}>
                    <div className="flex justify-center">
                        <TankWithPositionTable tanks={filteredTanks} />
                    </div>
                </ORB4CoverPage>
            ) : null}

            <div className="py-4 newpage">
                <ORB4Print
                    key={'temp-print-id-orb4'}
                    isPrintVisible={true}
                    orb4Records={historyList}
					vesselId={vesselId}
                />
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const orb4RecordStore = orb4Selectors._getStore(store);
    const marpolStore = marpolSelectors._getStore(store);
    const tanks = marpolSelectors.getTanks(marpolStore);

    return {
        historyList: orb4Selectors.getHistoryList(orb4RecordStore),
        jobToLoadHistory: orb4Selectors.jobToLoadHistory(orb4RecordStore),
        tanks,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {
        load(filters: TORB4HistoryFilters) {
            return dispatch(orb4Actions.commands.historyLoad(filters));
        },
    };
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ORB4InspectorView);
